import { type NavigateFunction } from 'react-router-dom'
import { type AppDispatch } from '../../../store/store'
import { initializeWebSocket } from '../../socket/initializeWebSocket'
import { updateUserTokenDevice } from '../../../store/actionsCreators/userActions'

import { USER_ID_KEY } from '../../../urls'


export const initializeFirebase = async (
    wb: WebSocket,
    dispatch: AppDispatch,
    navigate: NavigateFunction,
    callbackSocket: any
): Promise<void> => {
    const userID = window.localStorage.getItem(USER_ID_KEY);
    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    };

    try {
        const { initializeApp } = await import('firebase/app');
        const firebaseApp = initializeApp(firebaseConfig);

        const { getMessaging, getToken, onMessage } = await import('firebase/messaging');
        const messaging = getMessaging(firebaseApp);

        const permission = Notification.permission;
        console.log('Notification.permission:', permission);

        if (permission === 'granted') {
            await tryGetFirebaseToken(messaging, dispatch, userID , getToken);
        } else if (permission === 'default') {
            const request = await Notification.requestPermission();
            if (request === 'granted') {
                await tryGetFirebaseToken(messaging, dispatch, userID , getToken);
            } else {
                await fallbackToBrowserToken(dispatch, userID);
                notifyDenied();
            }
        } else if (permission === 'denied') {
            await fallbackToBrowserToken(dispatch, userID);
            notifyDenied();
        }

        initializeWebSocket(wb, dispatch, navigate, callbackSocket, { caller: 'firebase-init' });

        onMessage(messaging, (payload) => {
            navigator.serviceWorker.ready
                .then((registration) => {
                    registration.showNotification(payload.notification?.title ?? '', {
                        body: payload.notification?.body ?? ''
                    });
                })
                .catch(console.log);
        });

    } catch (err) {
        console.error('Firebase init error:', err);
    }
};




async function tryGetFirebaseToken(messaging: any, dispatch: AppDispatch, userID: string | null , getToken : any) {
    try {
        const currentToken = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
        });
        if (currentToken) {
            console.log('FB Token:', currentToken.slice(0, 5) + '...');
            await dispatch(updateUserTokenDevice(currentToken));
        } else {
            console.warn('No Firebase token, fallback');
            await fallbackToBrowserToken(dispatch, userID);
        }
    } catch (err) {
        console.error('Error getting Firebase token:', err);
        await fallbackToBrowserToken(dispatch, userID);
    }
}

async function fallbackToBrowserToken(dispatch: AppDispatch, userID: string | null) {
    await dispatch(updateUserTokenDevice(`BrowserToken${userID}`));
}

function notifyDenied() {
    console.log(
        'Notifications are blocked. To enable them, go to your browser settings and allow notifications for this site.'
    );
}

